import { render, staticRenderFns } from "./FormaDePagamento.vue?vue&type=template&id=73ec381a&scoped=true&"
import script from "./FormaDePagamento.vue?vue&type=script&lang=js&"
export * from "./FormaDePagamento.vue?vue&type=script&lang=js&"
import style0 from "./FormaDePagamento.vue?vue&type=style&index=0&id=73ec381a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ec381a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
